module.exports = __webpack_public_path__ + "static/media/culture.67867c20.png";